import { isProduction } from "./environmentUtilities";

const showDelimiterInDebugConsole = () => {
    console.debug('');
};

export function showDebugInfoForAudioUploadValidation(inputFile, duration) {
    if (isProduction())
        return;

    showDelimiterInDebugConsole();
    console.debug('Audio upload validation:');
    console.debug(`Input audio file size: ${inputFile.size} bytes => ${inputFile.size / 1024 / 1024} megabytes.`);
    console.debug(`Input audio file duration: ${duration} seconds => ${duration / 60 / 60} hours.`);
    showDelimiterInDebugConsole();
};

export function showDebugInfoForAudioAnalysisSizeValidation(audioSize, sizeLimit) {
    if (isProduction())
        return;

    showDelimiterInDebugConsole();
    console.debug('Audio analysis size validation:');
    console.debug(`Input: ${audioSize} bytes => ${audioSize / 1024 / 1024} megabytes.`);
    console.debug(`Limit: ${sizeLimit} megabytes.`);
    showDelimiterInDebugConsole();
};

export function showDebugInfoForAudioAnalysisDurationValidation(audioDuration, durationLimit) {
    if (isProduction())
        return;

    showDelimiterInDebugConsole();
    console.debug('Audio analysis duration validation');
    console.debug(`Input: ${audioDuration} seconds => ${audioDuration / 60} minutes.`);
    console.debug(`Limit: ${durationLimit} seconds => ${durationLimit / 60} minutes.`);
    showDelimiterInDebugConsole();
};